

import { defineComponent,PropType,ref,Ref,provide,watchEffect,onMounted,computed } from 'vue';
import {UserService} from "@/services/user.service";
import {useStore} from "vuex";

  export default defineComponent({
   name: "Header",
   props:{
      
    },
    setup(props,context){
      const store = useStore();
      const serviceUser = new UserService();

      onMounted(()=>{
	try{
	const userStored =  serviceUser.fetch();
	  if (userStored!=null){
	   store.dispatch("set_current_user",userStored);
	  }
	}catch(err){
	  console.log(err);
	}
      });
      const ayosh = (event)=> context.emit("ayosh",event.target.value);
      
      const cUser = computed( ()=>{ return  store.getters.getCurrentUser});
      return {cUser,ayosh}
    }
  });
